import * as React from 'react';
import { Pressable, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface RadioProps {
  onPress: () => void;
  active?: boolean;
  disabled?: boolean;
}

export const Radio = ({
  onPress,
  active = false,
  disabled = false,
}: RadioProps) => {
  const { styles, theme } = useStyles(stylesheet);

  const renderRadio = React.useMemo(() => {
    const getTypeStyle = () => {
      let stateStyle = styles.default;

      if (disabled) {
        stateStyle = styles.disabled;
      }

      if (active) {
        stateStyle = styles.active;
      }

      return [stateStyle];
    };

    return (
      <Pressable
        style={[styles.radio, getTypeStyle()]}
        hitSlop={8}
        onPress={onPress}
      >
        {active ? (
          <View
            style={{
              backgroundColor: theme.colors.radio.iconColor,
              width: 12,
              height: 12,
              borderRadius: 100,
            }}
          />
        ) : null}
      </Pressable>
    );
  }, [active, disabled, styles, onPress]);

  return <View>{renderRadio}</View>;
};

const stylesheet = createStyleSheet((theme) => ({
  radio: {
    width: 24,
    height: 24,
    borderRadius: 100,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  default: {
    backgroundColor: theme.colors.radio.default.backgroundColor,
    borderColor: theme.colors.radio.default.border,
  },
  active: {
    backgroundColor: theme.colors.radio.active.backgroundColor,
    borderColor: theme.colors.radio.active.border,
  },
  disabled: {
    backgroundColor: theme.colors.radio.disabled.backgroundColor,
    borderColor: theme.colors.radio.disabled.border,
  },
}));
